import { render, staticRenderFns } from "./UserPendingInvitesItem.vue?vue&type=template&id=405885c8&"
import script from "./UserPendingInvitesItem.vue?vue&type=script&lang=js&"
export * from "./UserPendingInvitesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports